import { useCallback, useMemo, useState } from 'react';

export enum OddsSorting {
  BestPrices = 'best-prices',
  Default = 'default',
}

export function useOddsSorting(): {
  items: { id: OddsSorting; label: string; selected: boolean }[];
  onSelectSorting: ({ id }: { id: OddsSorting }) => void;
  sorting: OddsSorting;
} {
  const [items, setItems] = useState<{ id: OddsSorting; label: string; selected: boolean }[]>([
    {
      id: OddsSorting.Default,
      label: 'Default',
      selected: true,
    },
    {
      id: OddsSorting.BestPrices,
      label: 'Best prices',
      selected: false,
    },
  ]);

  const onSelectSorting = useCallback(({ id }: { id: OddsSorting }) => {
    setItems(items =>
      items.map(item => ({
        ...item,
        selected: item.id === id,
      })),
    );
  }, []);

  const sorting = useMemo(() => {
    const index = items.findIndex(i => i.selected);
    return index >= 0 ? items[index].id : OddsSorting.Default;
  }, [items]);

  return useMemo(
    () => ({
      items,
      onSelectSorting,
      sorting,
    }),
    [items, onSelectSorting, sorting],
  );
}
